import { ApplicationUser, Organisation, Permission, Team, ValueLabelResponse } from 'types';
import {
  AddTeamResponse,
  GetAllTeamsResponse,
  GetTeamsResponse,
  UpdateTeamResponse,
} from 'api';

export const MOCK_ORGANISATIONS: Organisation[] = [
  { organisationName: 'Organisation 1', id: 1, email: 'email1@org.org' },
  { organisationName: 'Organisation 2', id: 2, email: 'email2@org.org' },
  { organisationName: 'Organisation 3', id: 3, email: 'email3@org.org' },
  { organisationName: 'Organisation 4', id: 4, email: 'email4@org.org' },
];

export const MOCK_TEAMS_DATA: Team[] = [
  {
    teamName: 'Team 1',
    teamId: 1,
    email: 'email1@Team.org',
    organisationId: 1,
    organisationName: 'Organisation 1',
    backOfficeCode: 'MGC-1',
    tenantId: '1',
  },
  {
    teamName: 'Team 2',
    teamId: 2,
    email: 'email2@Team.org',
    organisationId: 2,
    organisationName: 'Organisation 2',
    backOfficeCode: 'MGC-2',
    tenantId: '1',
  },
  {
    teamName: 'Team 3',
    teamId: 3,
    email: 'email3@Team.org',
    organisationId: 3,
    organisationName: 'Organisation 3',
    backOfficeCode: 'MGC-3',
    tenantId: '1b',
  },
  {
    teamName: 'Team 4',
    teamId: 4,
    email: 'email4@Team.org',
    organisationId: 4,
    organisationName: 'Organisation 4',
    backOfficeCode: 'MGC-4',
    tenantId: '1a',
  },
];

export const MOCK_TEAM_OPTIONS: ValueLabelResponse[] = [
  { label: 'Belfast city team', value: 0 },
  { label: 'RPC', value: 1 },
  { label: 'Planning committee', value: 2 },
  { label: 'Subject Matter Experts', value: 3 },
];

export const MOCK_PERMISSIONS: ValueLabelResponse[] = [
  {
    label: Permission.Admin,
    value: 1,
  },
  {
    label: Permission.Consultee,
    value: 2,
  },
  {
    label: Permission.TQAdmin,
    value: 3,
  },
];

export const MOCK_PERMISSIONS_NEW_TENANT: ValueLabelResponse[] = [
  {
    label: Permission.Admin,
    value: 4,
  },
  {
    label: Permission.Consultee,
    value: 5,
  },
  {
    label: Permission.TQAdmin,
    value: 6,
  },
];

export const MOCK_USER_DATA: ApplicationUser[] = [
  {
    id: 10000001,
    name: 'name1',
    email: 'user1@email.com',
    teams: [MOCK_TEAM_OPTIONS[0]],
    permission: MOCK_PERMISSIONS[0],
    isRegistered: true,
  },
  {
    id: 10000002,
    name: 'name2',
    email: 'user2@email.com',
    teams: [
      MOCK_TEAM_OPTIONS[0],
      MOCK_TEAM_OPTIONS[1],
      MOCK_TEAM_OPTIONS[2],
      MOCK_TEAM_OPTIONS[3],
    ],
    permission: MOCK_PERMISSIONS[0],
    isRegistered: true,
  },
  {
    id: 10000003,
    name: 'name3',
    email: 'user3@email.com',
    teams: [MOCK_TEAM_OPTIONS[0]],
    permission: MOCK_PERMISSIONS[1],
    isRegistered: true,
  },
  {
    id: 10000004,
    name: 'name4',
    email: 'user4@email.com',
    teams: [MOCK_TEAM_OPTIONS[1], MOCK_TEAM_OPTIONS[2]],
    permission: MOCK_PERMISSIONS[0],
    isRegistered: true,
  },
  {
    id: 10000005,
    name: 'name5',
    email: 'user5@email.com',
    teams: [MOCK_TEAM_OPTIONS[3]],
    permission: MOCK_PERMISSIONS[1],
    isRegistered: false,
  },
  {
    id: 10000006,
    name: 'name6',
    email: 'user6@email.com',
    teams: [MOCK_TEAM_OPTIONS[0]],
    permission: MOCK_PERMISSIONS[0],
    isRegistered: true,
  },
  {
    id: 10000007,
    name: 'name7',
    email: 'user7@email.com',
    teams: [
      MOCK_TEAM_OPTIONS[0],
      MOCK_TEAM_OPTIONS[1],
      MOCK_TEAM_OPTIONS[2],
      MOCK_TEAM_OPTIONS[3],
    ],
    permission: MOCK_PERMISSIONS[0],
    isRegistered: true,
  },
  {
    id: 10000008,
    name: 'name8',
    email: 'user8@email.com',
    teams: [MOCK_TEAM_OPTIONS[0]],
    permission: MOCK_PERMISSIONS[1],
    isRegistered: true,
  },
  {
    id: 10000009,
    name: 'name9',
    email: 'user9@email.com',
    teams: [MOCK_TEAM_OPTIONS[1], MOCK_TEAM_OPTIONS[2]],
    permission: MOCK_PERMISSIONS[0],
    isRegistered: true,
  },
  {
    id: 10000010,
    name: 'name10',
    email: 'user10@email.com',
    teams: [MOCK_TEAM_OPTIONS[3]],
    permission: MOCK_PERMISSIONS[1],
    isRegistered: false,
  },
  {
    id: 10000011,
    name: 'name11',
    email: 'user11@email.com',
    teams: [MOCK_TEAM_OPTIONS[3]],
    permission: MOCK_PERMISSIONS[1],
    isRegistered: false,
  },
];

export const MOCK_USER_ADMIN_DATA: ApplicationUser[] = [
  {
    id: 10000001,
    name: 'name admin1',
    email: 'user-admin1@email.com',
    teams: [MOCK_TEAM_OPTIONS[0]],
    permission: MOCK_PERMISSIONS[2],
    isRegistered: true,
  },
];

export const MOCK_ALL_TEAMS_RESPONSE: GetAllTeamsResponse = {
  organisations: MOCK_TEAM_OPTIONS,
};

export const MOCK_ADD_TEAM_RESPONSE: AddTeamResponse = {
  teamId: 1,
};

export const MOCK_UPDATE_TEAM_RESPONSE: UpdateTeamResponse = {
  id: 1,
};

const paginationInfo = {
  currentPage: 1,
  pageSize: 10,
  totalCount: 4,
  totalPages: 1,
};

export const MOCK_GET_TEAMS_RESPONSE: GetTeamsResponse = {
  teams: {
    items: MOCK_TEAMS_DATA,
  },
  paginationInfo,
};
